// @flow weak

import { isEmpty } from 'lodash';

import {
  addTruthyParamsToUrl,
  splitUrl,
  splitUrlPiece,
  stripTerminalSlashes,
} from '@zapier/common-utils';

import {
  IMAGE_SERVICE_URL,
  INVALID_IMAGE_CDN_URLS,
} from 'web-ssr/app/common/constants';

// Strips possible leading and trailing slashes and
// then adds them back to ensure they're always there
// and not doubled up. It's important to have the slashes
// to prevent something like `/dashboard` from matching
// `/dashboard-items` which is likely a completely
// different route.
// If the `retainHashOrQuery` argument is passed as truthy, then it
// will retain the hash or query string attached to the original `pathname`.
export const normalizePathname = (pathname, retainHashOrQuery = false) => {
  const query = splitUrl(pathname);
  const hash = splitUrlPiece('#', query.baseHref);

  const cleanPath = `/${stripTerminalSlashes(hash.baseHref)}/`;

  if (retainHashOrQuery) {
    const hashStr = isEmpty(hash.queryString) ? '' : `#${hash.queryString}`;
    const queryStr = isEmpty(query.queryString) ? '' : `?${query.queryString}`;

    return `${cleanPath}${queryStr}${hashStr}`;
  }

  return cleanPath;
};

export const addProtocolToUrl = (url: string, protocol: string) => {
  const httpProtocolMatch = url.match(/^https?:\/\//);
  if (httpProtocolMatch && httpProtocolMatch.index === 0) {
    return url;
  }

  return `${protocol}${url}`;
};

const replaceImageCDN = (src: string) => {
  const match = INVALID_IMAGE_CDN_URLS.find(url => src.includes(url));

  return match ? src.replace(match, IMAGE_SERVICE_URL) : src;
};

export const buildOptimzedImageUrl = (
  src: string,
  width?: number,
  format?: string,
  background?: string
) =>
  addTruthyParamsToUrl(replaceImageCDN(src), {
    dimensions: width,
    format,
    background,
  });

export const isRelativeAnchorLink = (target: URL) => {
  const { location } = window;

  return Boolean(
    target.hash &&
      location.pathname === target.pathname &&
      location.origin === target.origin
  );
};
